import { gql } from '../../../apollo/__generated__';

export const CONFIRM_USER_HERE_WITH_CODE = gql(`
  mutation ConfirmUserHereWithCode($code: String!, $eventId: ID!) {
    confirmUserHere(code: $code, eventId: $eventId) {
      id
      email
      firstname
      nickname
      lastname
      studyTown
      pastEvents {
        id
        name
      }
      hasCaution(eventId: $eventId)
      hasPaidTicket(eventId: $eventId)
      isNoAlcool(eventId: $eventId)
      isValidated(eventId: $eventId)
      isHere(eventId: $eventId)
      userComment(eventId: $eventId)
      orgaComment(eventId: $eventId)
      bedroom(eventId: $eventId) {
        id
        floor
        doorNumber
      }
    }
  }
`);

export const CONFIRM_USER_HERE_WITH_USER_ID = gql(`
  mutation ConfirmUserHereWithUserId($userId: ID!, $eventId: ID!) {
    confirmUserHere(userId: $userId, eventId: $eventId) {
      id
      email
      firstname
      nickname
      lastname
      studyTown
      pastEvents {
        id
        name
      }
      hasCaution(eventId: $eventId)
      hasPaidTicket(eventId: $eventId)
      isNoAlcool(eventId: $eventId)
      isValidated(eventId: $eventId)
      isHere(eventId: $eventId)
      userComment(eventId: $eventId)
      orgaComment(eventId: $eventId)
      bedroom(eventId: $eventId) {
        id
        floor
        doorNumber
      }
    }
  }
`);
